const documentPanel = {
    namespaced: true,
    state: {
        showRouteParamPanel: false,
    },
    mutations: {
        SET_SHOW_ROUTEPARAM_TAB(state, payload) {           
            state.showRouteParamPanel = payload;
        },
    },
    getters: {
        showRouteParamPanel: (s) => s.showRouteParamPanel,
    },
};

export default documentPanel;